var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 78,
    viewBox: "0 0 86 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17793",
    "data-name": "Rectangle 17793",
    width: 85.729,
    height: 77.439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17782",
    "data-name": "Rectangle 17782",
    width: 47.758,
    height: 58.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17783",
    "data-name": "Rectangle 17783",
    width: 6.827,
    height: 7.915,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17784",
    "data-name": "Rectangle 17784",
    width: 21.503,
    height: 31.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17786",
    "data-name": "Rectangle 17786",
    width: 4.52,
    height: 4.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17787",
    "data-name": "Rectangle 17787",
    width: 4.798,
    height: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17788",
    "data-name": "Rectangle 17788",
    width: 24.7,
    height: 24.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17789",
    "data-name": "Rectangle 17789",
    width: 22.317,
    height: 22.317,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17790",
    "data-name": "Rectangle 17790",
    width: 18.201,
    height: 18.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17791",
    "data-name": "Rectangle 17791",
    width: 17.875,
    height: 31.61,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35293",
    "data-name": "Group 35293",
    transform: "translate(-278 -575.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17795",
    "data-name": "Rectangle 17795",
    width: 86,
    height: 78,
    transform: "translate(278 575.572)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35290",
    "data-name": "Group 35290",
    transform: "translate(278.136 575.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35289",
    "data-name": "Group 35289",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35288",
    "data-name": "Group 35288",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35287",
    "data-name": "Group 35287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44255",
    "data-name": "Path 44255",
    d: "M51.307,1.123a42.452,42.452,0,0,0-40.53,12.314,46.928,46.928,0,0,0-5.735,7.811C.813,28.477-1.514,43.081,1.106,51.221,5.983,66.376,20.353,74.253,36.283,76.743,52.851,79.332,68.612,74.663,80,63.825c4.581-4.359,6.343-11.6,5.538-17.86-.5-3.868-1.771-7.284-4.692-9.764-3.088-2.621-6.7-3.736-9.967-5.859a21.818,21.818,0,0,1-7.335-8.6,15.639,15.639,0,0,1-1.856-6.538c-.05-2.814.494-5.784-.6-8.461-1.414-3.467-6.328-4.785-9.786-5.624",
    transform: "translate(-0.001 -0.003)",
    fill: "#f4f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44256",
    "data-name": "Path 44256",
    d: "M272.687,132.27l-2.034,13.679-5.261,35.386a4.282,4.282,0,0,1-4.865,3.606l-8.151-1.212L222.9,179.346l-1.136-.169a4.282,4.282,0,0,1-3.606-4.865l4.742-31.9,2.445-16.44.108-.727a4.283,4.283,0,0,1,4.865-3.606l26.367,3.92,7.116,1.058,5.284.785a4.282,4.282,0,0,1,3.606,4.865",
    transform: "translate(-204.752 -114.149)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35262",
    "data-name": "Group 35262",
    transform: "translate(18.143 11.412)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35261",
    "data-name": "Group 35261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35260",
    "data-name": "Group 35260",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44257",
    "data-name": "Path 44257",
    d: "M344.085,194.3v12.473l-5.261,35.386a4.259,4.259,0,0,1-1.2,2.394H325.808l-29.481-4.383v-49.5a4.278,4.278,0,0,1,4.282-4.282H336.17l1.058,1.058Z",
    transform: "translate(-296.327 -186.387)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44258",
    "data-name": "Path 44258",
    d: "M321.967,172.184v45.971a4.281,4.281,0,0,1-4.282,4.282H278.491a4.281,4.281,0,0,1-4.282-4.282v-49.6a4.281,4.281,0,0,1,4.282-4.282h35.561Z",
    transform: "translate(-257.42 -154.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35265",
    "data-name": "Group 35265",
    transform: "translate(57.72 11.146)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35264",
    "data-name": "Group 35264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35263",
    "data-name": "Group 35263",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44259",
    "data-name": "Path 44259",
    d: "M949.549,188.874v1.089H947a4.281,4.281,0,0,1-4.282-4.282v-3.633Z",
    transform: "translate(-942.722 -182.047)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35268",
    "data-name": "Group 35268",
    transform: "translate(43.044 31.494)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35267",
    "data-name": "Group 35267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35266",
    "data-name": "Group 35266",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44260",
    "data-name": "Path 44260",
    d: "M723.116,514.923a16.05,16.05,0,0,0-4.131-.537,15.963,15.963,0,0,0-15.963,15.963,16.04,16.04,0,0,0,.537,4.131,16,16,0,0,0,20.966,10.847V515.37q-.692-.256-1.409-.447m-16.472,15.9V530.8c0,.055,0,.11.007.165,0-.048-.006-.1-.007-.144m.09,1.094c0-.029-.007-.058-.01-.088s-.006-.044-.008-.067-.008-.072-.012-.109c.005.058.013.117.02.175s.015.116.022.174c0-.029-.008-.057-.012-.087m.257,1.382c-.027-.113-.053-.226-.078-.341.038.175.079.35.124.521l-.047-.18m.2.7c-.013-.04-.024-.079-.036-.118l.047.15-.011-.032m.252.73c-.013-.036-.026-.071-.04-.107s-.018-.049-.026-.073l-.005-.017c.032.089.065.177.1.265l-.027-.068m.11.28c-.01-.025-.019-.05-.029-.075.019.047.037.094.058.141-.01-.022-.019-.044-.028-.066m.575,1.211-.056-.1c-.011-.02-.021-.041-.031-.061.042.08.085.16.129.239-.014-.025-.028-.049-.042-.075m.22.388.049.082s0,0,0,0c-.017-.028-.035-.058-.051-.087m11.532-18.58.185.014.183.017.021,0c-.13-.014-.259-.024-.39-.034m.629.06.05.006.086.012-.136-.018m1.262.224c.057.013.113.026.17.04l.185.047.106.029c-.153-.041-.307-.08-.461-.116m.6.154c.048.013.1.026.143.041l.129.039.033.011c-.1-.032-.2-.062-.3-.091m.94.31.064.024.068.027-.132-.05m.268.1c.025.01.051.019.076.03l.066.027-.141-.058m.145.058.069.029.067.029-.136-.058",
    transform: "translate(-703.022 -514.386)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44261",
    "data-name": "Path 44261",
    d: "M1079.583,910.41,1077.5,912.5l-12.417-12.417-2.435-2.435-.942-.942,2.085-2.085.942.942,2.435,2.435Z",
    transform: "translate(-996.699 -839.842)",
    fill: "#bdd9e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35271",
    "data-name": "Group 35271",
    transform: "translate(65.947 55.717)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35270",
    "data-name": "Group 35270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35269",
    "data-name": "Group 35269",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17785",
    "data-name": "Rectangle 17785",
    width: 2.949,
    height: 3.443,
    transform: "translate(0 2.085) rotate(-45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44262",
    "data-name": "Path 44262",
    d: "M1148.03,984.025l-11.11-11.11a1.037,1.037,0,0,1,0-1.467l1.617-1.617a1.037,1.037,0,0,1,1.467,0l11.11,11.11a1.037,1.037,0,0,1,0,1.467l-1.617,1.617a1.038,1.038,0,0,1-1.467,0",
    transform: "translate(-1067.024 -910.166)",
    fill: "#024266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44263",
    "data-name": "Path 44263",
    d: "M1068.764,899.427l-2.248,2.248a.991.991,0,0,1-1.4,0l-.222-.223-.811-.811a.99.99,0,0,1,0-1.4l2.248-2.248a.99.99,0,0,1,1.4,0l.859.858.175.175a.991.991,0,0,1,0,1.4",
    transform: "translate(-998.658 -841.8)",
    fill: "#bdd9e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35274",
    "data-name": "Group 35274",
    transform: "translate(65.133 54.903)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35273",
    "data-name": "Group 35273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35272",
    "data-name": "Group 35272",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44264",
    "data-name": "Path 44264",
    d: "M1067.73,896.993a.99.99,0,0,0-1.4,0l-2.248,2.248a.99.99,0,0,0,0,1.4l.811.811a16.243,16.243,0,0,0,3.7-3.6Z",
    transform: "translate(-1063.791 -896.702)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44265",
    "data-name": "Path 44265",
    d: "M689.324,494.845a15.869,15.869,0,0,0-7.156-4.138,16.045,16.045,0,0,0-4.131-.537,15.963,15.963,0,0,0-15.963,15.963,16.049,16.049,0,0,0,.537,4.131,15.977,15.977,0,0,0,24.57,8.957q.455-.32.891-.673a16.1,16.1,0,0,0,1.252-1.128q.451-.451.86-.93.363-.425.694-.87a15.972,15.972,0,0,0-1.554-20.775m-11.287,23.637a12.355,12.355,0,0,1-10.587-6l-.005-.009c-.033-.055-.066-.11-.1-.166-.024-.041-.047-.082-.07-.123-.034-.059-.067-.12-.1-.181l-.056-.1q-.216-.407-.4-.831c-.02-.046-.04-.092-.06-.138s-.039-.093-.058-.139c-.038-.093-.075-.186-.11-.28-.014-.035-.027-.071-.04-.107s-.019-.049-.027-.073-.025-.069-.037-.1q-.079-.222-.148-.447c-.014-.043-.027-.086-.039-.129s-.029-.1-.042-.146-.025-.088-.037-.133-.019-.07-.029-.106l-.047-.185c-.028-.113-.054-.227-.078-.341-.009-.042-.018-.083-.026-.125-.021-.1-.042-.208-.06-.313l-.017-.1c-.029-.166-.053-.334-.075-.5-.006-.051-.013-.1-.019-.154s-.012-.1-.017-.156-.012-.122-.017-.184-.011-.142-.016-.214-.008-.121-.011-.182-.007-.136-.009-.2q0-.068,0-.135c0-.042,0-.083,0-.124q0-.109,0-.217a12.364,12.364,0,0,1,12.35-12.35l.217,0,.124,0,.136,0,.2.009.182.011c.072.005.143.01.214.017l.184.017.156.017.154.019c.169.022.337.046.5.075l.1.017c.105.019.209.039.313.06l.125.027c.115.024.228.05.341.078l.185.047.106.029.133.037.146.042.129.039q.226.07.448.148l.1.037.073.026.107.04c.094.035.188.072.28.11l.139.058.138.06q.424.185.831.4l.1.056c.061.033.121.066.181.1l.123.07.166.1.009.005a12.348,12.348,0,0,1-6.354,22.936",
    transform: "translate(-621.537 -460.157)",
    fill: "#bdd9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44266",
    "data-name": "Path 44266",
    d: "M745.781,561.526a12.374,12.374,0,1,1-3.182-8.267,12.363,12.363,0,0,1,3.182,8.267",
    transform: "translate(-676.931 -515.552)",
    fill: "#006494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35277",
    "data-name": "Group 35277",
    transform: "translate(44.15 19.526)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35276",
    "data-name": "Group 35276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35275",
    "data-name": "Group 35275",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44267",
    "data-name": "Path 44267",
    d: "M745.781,561.526a12.374,12.374,0,1,1-3.182-8.267,12.363,12.363,0,0,1,3.182,8.267",
    transform: "translate(-721.081 -535.078)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44268",
    "data-name": "Path 44268",
    d: "M759.524,575.27A10.354,10.354,0,1,1,756.342,567a12.363,12.363,0,0,1,3.182,8.267",
    transform: "translate(-690.675 -529.295)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35280",
    "data-name": "Group 35280",
    transform: "translate(40.537 30.012)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35279",
    "data-name": "Group 35279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35278",
    "data-name": "Group 35278",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44269",
    "data-name": "Path 44269",
    d: "M684.391,495.545l-.009-.005-.166-.1c-.041-.024-.082-.047-.123-.07-.06-.034-.12-.067-.181-.1-.034-.019-.069-.037-.1-.056q-.407-.216-.831-.4l-.138-.06-.139-.058c-.092-.038-.186-.075-.28-.11-.035-.014-.071-.027-.107-.04l-.073-.026c-.034-.014-.069-.026-.1-.037q-.222-.078-.447-.148l-.129-.039-.146-.042-.133-.037-.106-.029-.185-.047c-.113-.028-.227-.054-.341-.078-.042-.009-.083-.019-.125-.027-.1-.022-.208-.042-.313-.06l-.1-.017c-.166-.029-.334-.053-.5-.075l-.154-.019-.156-.017-.184-.017c-.071-.007-.142-.012-.214-.017l-.182-.011-.2-.009-.135,0-.124,0-.217,0a12.364,12.364,0,0,0-12.35,12.35q0,.109,0,.217c0,.042,0,.082,0,.124s0,.09,0,.135c0,.068.006.136.009.2s.007.122.011.182.01.143.016.214.011.123.017.184.011.1.017.156.011.1.019.154c.022.169.046.337.075.5.005.033.011.065.017.1.019.105.039.209.06.313.008.042.017.084.026.125.024.115.05.228.078.341q.023.092.047.185c.009.036.019.071.029.106s.024.089.037.133.027.1.042.146.026.086.039.129q.07.226.148.447c.011.034.024.069.037.1s.017.049.027.073.026.072.04.107c.035.094.072.188.11.28.019.047.038.093.058.139s.039.092.06.138q.185.424.4.831c.019.034.037.07.056.1.033.061.066.121.1.181.023.042.046.083.07.123.032.056.065.111.1.166l.005.009a13.844,13.844,0,0,1-4.839-2.222,16.047,16.047,0,0,1-.537-4.131,15.963,15.963,0,0,1,15.963-15.963,16.046,16.046,0,0,1,4.131.537,13.841,13.841,0,0,1,2.222,4.839",
    transform: "translate(-662.074 -490.169)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35283",
    "data-name": "Group 35283",
    transform: "translate(45.046 34.521)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35282",
    "data-name": "Group 35282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35281",
    "data-name": "Group 35281",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44270",
    "data-name": "Path 44270",
    d: "M753.922,568a13.914,13.914,0,0,1-2.74,8.329q-.289.391-.609.764-.358.422-.754.817a14.171,14.171,0,0,1-1.1.99q-.382.311-.782.591a13.915,13.915,0,0,1-8.028,2.523,14.111,14.111,0,0,1-2.863-.291,12.347,12.347,0,0,1,16.586-16.586,14.111,14.111,0,0,1,.291,2.863",
    transform: "translate(-735.721 -563.816)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44271",
    "data-name": "Path 44271",
    d: "M845.872,672.219a1.32,1.32,0,0,1-.936-.388l-8.921-8.921a1.324,1.324,0,1,1,1.872-1.872l8.921,8.921a1.324,1.324,0,0,1-.936,2.26",
    transform: "translate(-784.463 -620.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44272",
    "data-name": "Path 44272",
    d: "M836.952,672.219a1.324,1.324,0,0,1-.936-2.26l8.921-8.921a1.324,1.324,0,1,1,1.873,1.872l-8.921,8.921a1.32,1.32,0,0,1-.936.388",
    transform: "translate(-784.464 -620.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35286",
    "data-name": "Group 35286",
    transform: "translate(22.777 18.299)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35285",
    "data-name": "Group 35285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35284",
    "data-name": "Group 35284",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44273",
    "data-name": "Path 44273",
    d: "M377.09,320.239a1.561,1.561,0,0,1-1.536-1.814,9.162,9.162,0,0,1,.567-2.054,6.42,6.42,0,0,1,2.9-2.99q.66-.4,1.627-.9a13.215,13.215,0,0,0,1.89-1.209,6.925,6.925,0,0,0,1.561-1.649,3.8,3.8,0,0,0,.638-2.176,3.594,3.594,0,0,0-.352-1.627,3.727,3.727,0,0,0-.923-1.187,3.84,3.84,0,0,0-1.341-.725,5.194,5.194,0,0,0-1.561-.242,4.53,4.53,0,0,0-1.759.33,6,6,0,0,0-1.429.835,7.028,7.028,0,0,0-1.143,1.143l-.01.013a1.561,1.561,0,0,1-2.112.324l-1.431-.987a1.562,1.562,0,0,1-.422-2.132,8.288,8.288,0,0,1,.809-1.065,9.287,9.287,0,0,1,2.154-1.781,10.09,10.09,0,0,1,2.616-1.1,11.27,11.27,0,0,1,2.9-.374,11.526,11.526,0,0,1,3.3.484,8.373,8.373,0,0,1,2.924,1.539,7.979,7.979,0,0,1,2.11,2.7,8.814,8.814,0,0,1,.813,3.935,8.5,8.5,0,0,1-.33,2.484,6.914,6.914,0,0,1-.945,1.956,8.241,8.241,0,0,1-1.451,1.583,16.549,16.549,0,0,1-1.89,1.363q-.88.528-1.758,1.011a10.593,10.593,0,0,0-1.6,1.077,5.24,5.24,0,0,0-1.187,1.363,3.035,3.035,0,0,0-.311.719,1.571,1.571,0,0,1-1.5,1.149Zm-1.585,8.686v-2.953a1.557,1.557,0,0,1,1.557-1.557h1.766a1.557,1.557,0,0,1,1.557,1.557v2.953a1.557,1.557,0,0,1-1.557,1.557h-1.766a1.557,1.557,0,0,1-1.557-1.557",
    transform: "translate(-372.006 -298.873)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_44274",
    "data-name": "Path 44274",
    d: "M361.43,304.579a1.561,1.561,0,0,1-1.536-1.814,9.16,9.16,0,0,1,.567-2.054,6.419,6.419,0,0,1,2.9-2.99q.66-.4,1.627-.9a13.211,13.211,0,0,0,1.89-1.209,6.924,6.924,0,0,0,1.561-1.649,3.8,3.8,0,0,0,.638-2.176,3.6,3.6,0,0,0-.352-1.627,3.727,3.727,0,0,0-.923-1.187,3.841,3.841,0,0,0-1.341-.725,5.194,5.194,0,0,0-1.561-.242,4.53,4.53,0,0,0-1.759.33,6,6,0,0,0-1.429.835,7.028,7.028,0,0,0-1.143,1.143l-.01.013a1.561,1.561,0,0,1-2.112.324l-1.431-.987a1.562,1.562,0,0,1-.422-2.132,8.285,8.285,0,0,1,.809-1.065,9.287,9.287,0,0,1,2.154-1.781,10.09,10.09,0,0,1,2.616-1.1,11.271,11.271,0,0,1,2.9-.374,11.522,11.522,0,0,1,3.3.484,8.37,8.37,0,0,1,2.924,1.539,7.978,7.978,0,0,1,2.11,2.7,8.813,8.813,0,0,1,.813,3.935,8.5,8.5,0,0,1-.33,2.484,6.914,6.914,0,0,1-.945,1.956A8.245,8.245,0,0,1,371.5,297.9a16.542,16.542,0,0,1-1.89,1.363q-.88.528-1.758,1.011a10.582,10.582,0,0,0-1.6,1.077,5.241,5.241,0,0,0-1.187,1.363,3.035,3.035,0,0,0-.311.719,1.571,1.571,0,0,1-1.5,1.149Zm-1.585,8.686v-2.953a1.557,1.557,0,0,1,1.557-1.557h1.766a1.557,1.557,0,0,1,1.557,1.557v2.953a1.557,1.557,0,0,1-1.557,1.557H361.4a1.557,1.557,0,0,1-1.557-1.557",
    transform: "translate(-334.528 -265.873)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44275",
    "data-name": "Path 44275",
    d: "M932.86,172.184h-3.634a4.281,4.281,0,0,1-4.282-4.282v-3.633Z",
    transform: "translate(-868.313 -154.211)",
    fill: "#f4f7f8"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.c9bf3bac719231ccba10becb73f218e5.svg";
export { ForwardRef as ReactComponent };